import { Link } from "react-router-dom";
import scrollToTop from "../components/scrolltoTop";

const GalleryLanding = () => {
  return (
    <>
      <div className="gallery-landing-page-container">
        <div className="gallery-landing-page-text">
          <div className="sticky">
            {" "}
            <img
              className="small-leaves leaves small-left-leaves"
              src="https://d1g9iww9o5ioh1.cloudfront.net/leaves/leftSmallLeaves.webp"
              alt=""
            />
            <h1>relive the moments</h1>
            <p>
              Explore memorable moments from our past events by browsing through
              our galleries.
            </p>
          </div>
        </div>
        <div className="past-events-container">
          <div className="past-event">
            <div className="past-event-content">
              <h4 className="past-event-name">Afrostalgia</h4>
              <span className="past-event-date">29/12/2023</span>
              <Link to="/gallery/afrostalgia" onClick={scrollToTop}>
                <button>View Gallery</button>
              </Link>
            </div>
          </div>
          <div className="past-event">
            <div className="past-event-content">
              <h4 className="past-event-name">Afrostalgia 2</h4>
              <span className="past-event-date">28/12/2024</span>
              <Link to="/gallery/afrostalgia2" onClick={scrollToTop}>
                <button>View Gallery</button>
              </Link>
            </div>
          </div>
          <div className="past-event">
            <div className="past-event-content">
              <h4 className="past-event-name">Afrosounds</h4>
              <span className="past-event-date">31/08/2024</span>
              <Link to="/gallery/afrosounds" onClick={scrollToTop}>
                <button>View Gallery</button>
              </Link>
            </div>
          </div>{" "}
          <div className="past-event">
            <div className="past-event-content">
              <h4 className="past-event-name">TAC Experience</h4>
              <span className="past-event-date">19/07/2024</span>
              <Link to="/gallery/tacexperience" onClick={scrollToTop}>
                <button>View Gallery</button>
              </Link>
            </div>
          </div>{" "}
          <div className="past-event">
            <div className="past-event-content">
              <h4 className="past-event-name">Introducing Summer</h4>
              <span className="past-event-date">31/05/2025</span>
              <Link to="/gallery/introsummer" onClick={scrollToTop}>
                <button>View Gallery</button>
              </Link>
            </div>
          </div>
          <div className="past-event">
            <div className="past-event-content">
              <h4 className="past-event-name">The Offseason</h4>
              <span className="past-event-date">07/09/2025</span>
              <Link to="/gallery/theoffseason" onClick={scrollToTop}>
                <button>View Gallery</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GalleryLanding;
